import * as Haptics from 'expo-haptics';

// One shared call, not five copies -- every pull-to-refresh in the app
// (Threads, Matches, Reveal requests, Preview x2) fires the exact same
// light tick the moment a pull is released, matching the tactile
// feedback Instagram/TikTok/Reddit all give on the same gesture
// (founder's own adversarial-lens audit, 2026-09-16: "Pull-to-refresh
// has no haptic"). Light, not Medium/Heavy -- this is a frequent,
// low-stakes action (unlike the "spark" moment's Success notification,
// a genuine one-time milestone), and a strong buzz on every single
// pull would read as annoying rather than delightful.
//
// Not gated on prefersReducedMotion -- that setting governs VISUAL
// motion (this app's own use-reduced-motion.ts hook, and every other
// call site that reads it in this codebase, is about animated
// transitions), not haptic/tactile feedback, which has no equivalent
// "reduce" signal on either platform. expo-haptics' own web
// implementation (confirmed by reading node_modules/expo-haptics/src/
// ExpoHaptics.web.ts) already no-ops safely everywhere it can't
// actually vibrate, so there's nothing here that needs its own guard.
export function pullToRefreshHaptic(): void {
  void Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
}
